
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"10","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{staticClass:"icon",attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{staticClass:"stroke",attrs:{"stroke":"#C5C5C5","stroke-width":"2","d":"M18.943 6.732v-3.51h-.85L17.218 1H2a1 1 0 00-1 1v6a1 1 0 001 1h15.212l.877-2.268h.854z"}}),_c('path',{staticClass:"fill",attrs:{"fill":"#C5C5C5","d":"M3 3h13v4H3z"}})])])
          )
        }
      }
    